<template>
  <div>
    <nba-full-stats
      :Position="Profile"
      :stats="seasonStats"
      v-if="sportId == 1"
    />

    <mlb-full-stats
      :Position="Profile"
      :stats="seasonStats"
      v-if="sportId == 2"
    />

    <nhl-full-stats
      :Position="Profile"
      :stats="seasonStats"
      v-if="sportId == 3"
    />
    <nfl-full-stats
      :Position="Profile"
      :stats="seasonStats"
      v-if="sportId == 4"
    />
    <!-- <p>{{ sportId }}</p> -->
  </div>
</template>

<script>
import MlbFullStats from "./playersFullStats/MlbFullStats.vue";
import NbaFullStats from "./playersFullStats/NbaFullStats.vue";
import NflFullStats from "./playersFullStats/NflFullStats.vue";
import NhlFullStats from "./playersFullStats/NhlFullStats.vue";

export default {
  components: { NbaFullStats, MlbFullStats, NhlFullStats, NflFullStats },
  name: "fullStats",
  props: {
    sportId: {
      type: [String, Number],
      default: "",
    },
    Profile: {
      type: Object,
      default: () => {},
    },
    seasonStats: {
      type: [Array, Object],
      default: () => [],
    },
  },
};
</script>
